import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {Component} from 'vue-property-decorator';

@Component
export default class AdminDatabaseSetupLayoutComponent extends VueWrapper {}
